 
import wndata from './wn_data.json'
import Vue from 'vue'
let notification = new Vue();
export default {
  shareJob(data) {
    console.log("sharejob data : ", data)
    console.log("jobid : ", wndata.selectedJobURL+data.jobAliasId)
    console.log("title : ", data.jobTitle)
    var vm = this;
    if (!navigator.share) return;

    navigator.share({
      url: wndata.selectedJobURL+data.jobAliasId,
      title: data.jobTitle,
      text: data.jobTitle+" | To see more information about this job ! please click on the link."
    })
    .then(() => { console.log("Shared job!!!!!"); })
    .catch((error) => { vm.$toast.info("No longer support this functionality in this device/browser") });
  },
  copyJobLink(data){
    var vm =this;
    var copiedlink = wndata.selectedJobURL+data.jobAliasId
    navigator.clipboard.writeText(copiedlink);
    notification.$toast.success(wndata.copylinkMessage)
  },
    convertLocalDateToUTCDate:function(date) {
        date = date+' ' + new Date().getHours() + ":" + new Date().getMinutes() + ":" + new Date().getSeconds()
        date = new Date(date);
        var convDate = new Date(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(), date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds());
        return convDate;
      },

    conversionbyNag:function(date) {
      var doo = new Date(date);
      //var timezoneoffset = -120; // gmt+2, == -120 (minutes)
      //console.log("NEW COnversion: "+ new Date( doo.getTime() - doo.getTimezoneOffset() * -60000 ) )
      return new Date( doo.getTime() - doo.getTimezoneOffset() * -60000 );
      
    },
    strToDate:function(strDate) {
      try{
       //-1 became javascript has months from 0-11
        return new Date(strDate.substring(0, 4), strDate.substring(5,7)-1,strDate.substring(8,10),12,0,0,0);
      }catch(e){
          console.log("Error in Date in conversion"+strDate)
      }
    },
    formatDateMoment:function(date) {
      try{
        return new Date(date.year(), date.month(),date.date(),12,0,0,0);
      }catch(e){
          console.log("Error in Date in conversion formatDate"+date)
      }
    },
    formatDateJS:function(date) {
      try{
        return new Date(date.getFullYear(), date.getMonth(),date.getDate(),12,0,0,0);
      }catch(e){
          console.log("Error in Date in conversion formatDate"+date)
      }
    }
}
